'use strict';


var Module = class {
	
	constructor() {
		this.name = 'mvc-mydashboard';
		this.current_version = "0.10.15.2021.10.25";
		
		this.global = null; // put by global on registration
		this.app = null;
		
		this.controllers = null;

		this.isready = false;
		this.isloading = false;

		this.clientapicontrollers = null; // API gateway

		this.client_wallet = null;

		this.currencies = null;
	}
	
	init() {
		console.log('module init called for ' + this.name);

		var global = this.global;
		
		this.isready = true;
	}

	async initAsync() {
		console.log('module initAsync called for ' + this.name);

		try {
			// mvc module
			var Client_Wallet = require('@primusmoney/client_wallet');

			this.client_wallet = Client_Wallet.getObject();

			if (this.client_wallet.initialized === false)
				throw 'client_wallet should be initialized before calling mvc-mydashboard.init';

			// get global object
			var clientglobal = this.client_wallet.getGlobalObject();
			// register this module
			this.global = clientglobal;

			// currencies module
			const Currencies = require('@primusmoney/currencies');
			//const Currencies = require('../../../../../nodemodules/@primusmoney/currencies');
			this.currencies = Currencies.getObject();
	
			await this.currencies.init();

			console.log('currency module is now initialized')
	
			this.isready = true;
	
			return true;
		}
		catch(e) {
			console.log('exception in mvc-mydashboard.initAsync: ' + e);
		}
	}


	
	// compulsory  module functions
	loadModule(parentscriptloader, callback) {
		console.log('loadModule called for module ' + this.name);
		
		if (this.isloading)
			return;
			
		this.isloading = true;

		var self = this;

		var modulescriptloader = parentscriptloader.getChildLoader('mvcmydashboardloader');

		modulescriptloader.load_scripts(function() { self.init(); if (callback) callback(null, self); });

		return modulescriptloader;	
	}
	
	isReady() {
		return this.isready;
	}

	hasLoadStarted() {
		return this.isloading;
	}

	// optional module functions
	registerHooks() {
		console.log('module registerHooks called for ' + this.name);
		
		var global = this.global;
		
		// initialization
	}
	
	postRegisterModule() {
		console.log('postRegisterModule called for ' + this.name);
		if (!this.isloading) {
			var global = this.global;
			var self = this;
			var rootscriptloader = global.getRootScriptLoader();
			
			this.loadModule(rootscriptloader, function() {
				if (self.registerHooks)
				self.registerHooks();
			});
		}
	}
	
	_getClientAPI() {
		if (this.clientapicontrollers)
			return this.clientapicontrollers;
		
		var global = this.global;
		
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		
		this.clientapicontrollers = mvcclientwalletmodule._getClientAPI();

		return  this.clientapicontrollers;
	}

	//
	// hooks
	//
	

	//
	// API
	//


// p2pmoney level (when we have an apicontroller)

	getAPIVersion() {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return  mvcclientwalletmodule.getAPIVersion();
	}

	getModulesVersions() {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var versioninfos = []

		const clientversion = _apicontrollers.getClientVersion()
			
		versioninfos.push({name: 'client', version: clientversion});


		const modulesversioninfo = _apicontrollers.getModulesVersionInfo();

		for (var i= 0; i < (modulesversioninfo ? modulesversioninfo.length : 0); i++) {
			var versioninfo = modulesversioninfo[i];
			versioninfos.push({name: versioninfo.label, version: versioninfo.value});
		}

		return versioninfos;
	}

	t(string) {
		// translation
		return this.global.t(string);
	}


	guid() {
		var global = this.global;
		var mvcclientwallet = global.getModuleObject('mvc-client-wallet');
		return mvcclientwallet.guid();
	}

	// events
	signalEvent(eventname, params) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.signalEvent(eventname, params);
	}
	
	registerEventListener(eventname, listerneruuid, callback) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.registerEventListener(eventname, listerneruuid, callback);
	}
	
	unregisterEventListener(eventname, listerneruuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.unregisterEventListener(eventname, listerneruuid);
	}
		
	//
	// Storage
	//

	// Settings
	async readSettings(keys, defaultvalue) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.readSettings(keys, defaultvalue);
	}
	
	async putSettings(keys, json) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.putSettings(keys, json);
	}

	//
	// vaults
	//
	_fillLocalVaultInfo(vaultinfo, vault) {
		vaultinfo.name = vault.name;
		vaultinfo.keyuuid = vault.keyuuid;
		vaultinfo.type = vault.type;
	}

	async getLocalVaultList(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	commonmodule = global.getModuleObject('common');

		var vaults = await new Promise((resolve, reject) => { 
					commonmodule.getVaultList(session, 0, (err, res) => {
						if (err) reject(err); else resolve(res);
					}); //  does not return a promise
				});

		var array = [];

		for (var i = 0; i < (vaults ? vaults.length : 0); i++) {
			var vault = vaults[i];
			var vaultinfo = {};
			
			this._fillLocalVaultInfo(vaultinfo, vault);

			array.push(vaultinfo);
		}


		return array;
	}
	
	//
	// Crypto functions
	//

	async isValidAddress(sessionuuid, address) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.isValidAddress(sessionuuid, address);
	}
	
	async generatePrivateKey(sessionuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.generatePrivateKey(sessionuuid);
	}

	async getPublicKeys(sessionuuid, privatekey ) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		return _apicontrollers.getPublicKeys(session, privatekey);
	}
	
	async isValidPrivateKey(sessionuuid, privatekey) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.isValidPrivateKey(sessionuuid, privatekey);
	}
	
	async areAddressesEqual(sessionuuid, address1, address2) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.areAddressesEqual(sessionuuid, address1, address2);
	}
	

	//
	// Session functions
	//

	async getCurrentSession() {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getCurrentSessionObject();

		if (!session)
			return Promise.reject('could not retrieve current session');

		var sessionuuid = session.getSessionUUID();

		return sessionuuid;
	}
	
	async setCurrentSession(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		_apicontrollers.setCurrentSessionObject(session);
	}

	async createBlankSession() {
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.createBlankSessionObject();

		if (!session)
			return Promise.reject('could not create session');

		var sessionuuid = session.getSessionUUID();

		return sessionuuid;
	}

	async authenticateSession(sessionuuid, username, password) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		return _apicontrollers.authenticate(session, username, password);
	}

	async getNodeInfo(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereumnodeaccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		var nodeinfo = {};

		nodeinfo.web3providerUrl = ethereumnodeaccess.web3_getProviderUrl();

		let _info = await ethereumnodeaccess.web3_getNodeInfo();

		nodeinfo = Object.assign(nodeinfo, _info);

		return nodeinfo;
	}

	async getEthNodeVersion(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var ethnodemodule = global.getModuleObject('ethnode');

		var ethereumnodeaccess = ethnodemodule.getEthereumNodeAccessInstance(session);

		if (ethereumnodeaccess.ethnode_version)
		return ethereumnodeaccess.ethnode_version();
	}



	_fillUserInfo(userinfo, user) {
		if (!user) return;

		userinfo.name = user.getUserName();
			
		userinfo.email = user.getUserEmail();
		
		userinfo.uuid = user.getUserUUID();

	}

	async getSessionUser(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var user = session.getSessionUserObject();
		var userinfo = {};
		
		this._fillUserInfo(userinfo, user);

		return userinfo;
	}

	async isAnonymousSession(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');

		return mvcclientwalletmodule._isAnonymousAsync(session);
	}

	async logoutSession(sessionuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		session.disconnectUser();
	}
	
	//
	// Accounts
	//

	_fillAccountInfo(accountinfo, account) {
		if (!account) return;

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		accountinfo.address = account.address;
		accountinfo.uuid = account.accountuuid;

		accountinfo['uuid'] = account.getAccountUUID();

		accountinfo['description'] = (account.getDescription() !== null ? account.getDescription() : account.getAddress());
		accountinfo['type'] = (account.getPrivateKey() !== null ? global.t('personal') : global.t('3rd party'));
		
		var origin = account.getOrigin();
		accountinfo['origin'] = (origin && origin.storage ?  global.t(origin.storage) : global.t('unknown'));
		
		accountinfo['address'] = account.getAddress();
		accountinfo['public_key'] = account.getPublicKey();
		accountinfo['rsa_public_key'] = account.getRsaPublicKey();

	}

	async getSessionAccounts(sessionuuid, bRefresh, bIncludeReadOnly) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var accounts;
		
		if (bIncludeReadOnly === true)
		accounts = await _apicontrollers.getAccountObjects(session, bRefresh);
		else
		accounts = await _apicontrollers.getSessionAccountObjects(session, bRefresh);

		var array = [];
		
		for (var i = 0; i < (accounts ? accounts.length : 0); i++) {
			var accountinfo = {};
			var account = accounts[i];
			
			this._fillAccountInfo(accountinfo, account);

			array.push(accountinfo);
		}

		return array;
	}

	async createAccount(sessionuuid, address, privatekey) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!address && !privatekey)
			return Promise.reject('address and private key are undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		// create object
		var account = await _apicontrollers.createAccountObject(session, address, privatekey);

		if (!account)
			return Promise.reject('could not create account');

		// then save
		var res = await _apicontrollers.saveAccountObject(session, account);

		var accountinfo = {};
		this._fillAccountInfo(accountinfo, account);
		
		return accountinfo;
	}

	async getAccountFromUUID(sessionuuid, accountuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!accountuuid)
			return Promise.reject('account uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var account = await _apicontrollers.getAccountObjectFromUUID(session, accountuuid);

		if (!account)
			return Promise.reject('could not find account ' + accountuuid);

		var accountinfo = {};
		this._fillAccountInfo(accountinfo, account);
		
		return accountinfo;
	}

	async setAccountInfo(sessionuuid, accountuuid, info) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!accountuuid)
			return Promise.reject('account uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var account = await _apicontrollers.getAccountObjectFromUUID(session, accountuuid);

		if (!account)
			return Promise.reject('could not find account ' + accountuuid);

		var sessionuser = session.getSessionUserObject();
		
		// modifiable fields
		account.setDescription(info.description);
				
		// we save this account
		var storagemodule = global.getModuleObject('storage-access');
		var storageaccess = storagemodule.getStorageAccessInstance(session);
		
		return storageaccess.user_update_account(sessionuser, account);
	}
	


	async getAccountBalance(sessionuuid, accountuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!accountuuid)
			return Promise.reject('account uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var account = await _apicontrollers.getAccountObjectFromUUID(session, accountuuid);

		if (!account)
			return Promise.reject('could not find account ' + accountuuid);

		return _apicontrollers.getEthAccountBalance(session, account);
	}

	_fillCryptoKeyInfo(cryptokeyinfo, cryptokey) {
		if (!cryptokey) return;

		cryptokeyinfo['uuid'] = cryptokey.getKeyUUID();

		cryptokeyinfo['description'] = cryptokey.getDescription();

		var origin = cryptokey.getOrigin();
		cryptokeyinfo['origin'] = (origin && origin.storage ?  origin.storage : 'unknown');
		
		cryptokeyinfo['address'] = cryptokey.getAddress();
		cryptokeyinfo['public_key'] = cryptokey.getPublicKey();
	}


	
	async getSessionCryptoKeys(sessionuuid, bRefresh) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();
		
		var session = await _apicontrollers.getSessionObject(sessionuuid);

		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var cryptokeys = await session.getSessionCryptoKeyObjects(bRefresh);

		var array = [];

		for (var i = 0; i < (cryptokeys ? cryptokeys.length : 0); i++) {
			var cryptokey = cryptokeys[i];
			var cryptokeyinfo = {};
			
			this._fillCryptoKeyInfo(cryptokeyinfo, cryptokey);

			array.push(cryptokeyinfo);
		}

		return array;
	}



	//
	// Ethereum transations
	//
	_fillEthereumTransactionInfo(transactioninfo, transaction) {
		if (!transaction) return;

		var global = this.global;

		transactioninfo.uuid = transaction.getTransactionUUID();
					
		var creationdate = transaction.getCreationDate();
		
		transactioninfo.unixdate = new Date((creationdate ? creationdate : 0)).getTime() / 1000;
		transactioninfo.date = global.formatDate(new Date(transactioninfo.unixdate*1000), 'YYYY-mm-dd HH:MM:SS');
		transactioninfo.transactionuuid = transaction.getTransactionUUID();
		transactioninfo.transactionhash = transaction.getTransactionHash();
		transactioninfo.from = transaction.getFrom();
		transactioninfo.to = transaction.getTo();
		transactioninfo.ethervalue = parseFloat(transaction.getValue());
		transactioninfo.value = ( transactioninfo.ethervalue ? transactioninfo.ethervalue.toFixed(2) + ' Ether' : '');

		transactioninfo.status = transaction.getStatus();
	}


	async getEthereumTransactions(sessionuuid, bRefresh) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var transactions = await _apicontrollers.getEthereumTransactionList(session, bRefresh);

		var array = [];

		for (var i = 0; i < (transactions ? transactions.length : 0); i++) {
			var transaction = transactions[i];
			var transactioninfo = {};
			
			this._fillEthereumTransactionInfo(transactioninfo, transaction);

			array.push(transactioninfo);
		}

		return array;

	}

	//
	// ERC20 tokens
	//
	_getERC20TokenStatusString(status) {
		const STATUS_LOST = -100;	

		const STATUS_NOT_FOUND = -20;	
		const STATUS_UNKOWN = -10;	
	
		const STATUS_LOCAL = 1;
		
		const STATUS_SENT = 10;	
		const STATUS_PENDING = 100;	
		
		const STATUS_DEPLOYED = 200;	
		const STATUS_CANCELLED = 300;	
		const STATUS_REJECTED = 400;	
		
		const STATUS_ON_CHAIN = 1000;
	
		switch(status) {
			case STATUS_LOST:
				return 'lost';
			case STATUS_NOT_FOUND:
				return 'not found';
			case STATUS_UNKOWN:
				return 'unknown';
			case STATUS_LOCAL:
				return 'local';
			case STATUS_SENT:
				return 'sent';
			case STATUS_PENDING:
				return 'pending';
			case STATUS_DEPLOYED:
				return 'deployed';
			case STATUS_CANCELLED:
				return 'cancelled';
			case STATUS_REJECTED:
				return 'rejected';
			case STATUS_ON_CHAIN:
				return 'on chain';
			default:
				return 'undefined';
		}
		
	}


	_fillERC20TokenInfo(erc20tokeninfo, erc20token) {
		if (!erc20token) return;

		erc20tokeninfo.index = erc20token.getContractIndex();
		erc20tokeninfo.uuid = erc20token.getUUID();

		erc20tokeninfo.address = erc20token.getAddress();

		erc20tokeninfo.localdescription = erc20token.getLocalDescription();
		erc20tokeninfo.localname = erc20token.getLocalName();
		erc20tokeninfo.localsymbol = erc20token.getLocalSymbol();
		erc20tokeninfo.localdecimals = erc20token.getLocalDecimals();
		erc20tokeninfo.localtotalsupply = erc20token.getLocalTotalSupply();

		erc20tokeninfo.web3providerurl = erc20token.getWeb3ProviderUrl();
		erc20tokeninfo.chainid = erc20token.getChainId();
		erc20tokeninfo.networkid = erc20token.getNetworkId();

		erc20tokeninfo.isLocalOnly = erc20token.isLocalOnly();
		
		erc20tokeninfo.status = erc20token.getStatus();
		erc20tokeninfo.statusstring = this._getERC20TokenStatusString(erc20tokeninfo.status);

		erc20tokeninfo.contracttype = erc20token.getContractType();

	}


	async getERC20Tokens(sessionuuid, bRefresh) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var erc20tokens = await	_apicontrollers.getERC20TokenList(session, bRefresh);

		var array = [];

		for (var i = 0; i < (erc20tokens ? erc20tokens.length : 0); i++) {
			var erc20token = erc20tokens[i];
			var erc20tokeninfo = {};
			
			this._fillERC20TokenInfo(erc20tokeninfo, erc20token);

			array.push(erc20tokeninfo);
		}

		return array;

	}

	async _saveERC20Tokens(session) {
		// TODO: add corresponding functions to _apicontrollers (version 0.30.10)

		if (!session)
			return Promise.reject('session is undefined');

		var global = this.global;
	
		var erc20tokenmodule = global.getModuleObject('erc20');
		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();

		return new Promise((resolve, reject) => { 
			erc20tokencontrollers.saveERC20Tokens(session, (err, res) => {
				if (err) reject(err); else resolve(res);
			}); //  does not return a promise
		});
	}

	async _createLocalERC20Token(session, data) {
		// TODO: add corresponding functions to _apicontrollers (version 0.30.10)
		var global = this.global;

		// call module controller
		var erc20tokenmodule = global.getModuleObject('erc20');

		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();

		// create (local) erc20token object for these values
		var erc20token = erc20tokencontrollers.createERC20TokenObject(session, data);
		
		return erc20token;
	}



	async _saveLocalERC20Token(session, erc20token) {
		// TODO: add corresponding functions to _apicontrollers (version 0.30.10)
		var global = this.global;

		// call module controller
		var erc20tokenmodule = global.getModuleObject('erc20');
		
		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();

		// save 
		return erc20tokencontrollers.saveERC20TokenObject(session, erc20token);
	}

	async createERC20Token(sessionuuid, data) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var erc20token;
		
		if (data.address) {
			// imported token
			erc20token = _apicontrollers.importERC20Token(session, data.address);

			// set description
			erc20token.setLocalDescription(data.description);

			// save a first time
			let saved_token = await _apicontrollers.saveERC20Token(session, erc20token);


			// fetch elements on the chain
/* 			var name = await erc20token.getChainName();
				
			erc20token.setLocalDescription(name);

			var symbol = await erc20token.getChainSymbol();
					
			erc20token.setLocalSymbol(symbol);
					
			var decimals = await erc20token.getChainDecimals();
					
			erc20token.setLocalDecimals(decimals);
					
			var totalsupply = await erc20token.getChainTotalSupply();
					
			erc20token.setLocalTotalSupply(totalsupply);

			// save now that we have the elments
			saved_token = await _apicontrollers.saveERC20Token(session, erc20token); */
		}
		else {
			// TODO: add corresponding functions to _apicontrollers (version 0.30.10)

			// create (local) erc20token object for these values
			erc20token = await this._createLocalERC20Token(session, data);

			// save 
			let res = await this._saveLocalERC20Token(session, erc20token);
		}

		// return tokeninfo
		var erc20tokeninfo = {};

		this._fillERC20TokenInfo(erc20tokeninfo, erc20token);

		return erc20tokeninfo;
	}

	_getERC20TokenFromUUID(session, erc20tokenuuid) {
		var global = this.global;

		var erc20tokenmodule = global.getModuleObject('erc20');
		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();
		
		var erc20token = erc20tokencontrollers.getERC20TokenFromUUID(session, erc20tokenuuid);

		return erc20token;
	}

	async getERC20TokenFromUUID(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		var erc20tokeninfo = {};

		this._fillERC20TokenInfo(erc20tokeninfo, erc20token);

		return erc20tokeninfo;
	}

	async setERC20TokenInfo(sessionuuid, erc20tokenuuid, info) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		// modifiable fields
		var res;
		erc20token.setLocalDescription(info.localdescription);

		if (erc20token.isLocalOnly()) {
			erc20token.setLocalName(info.localname);
			erc20token.setLocalSymbol(info.localsymbol);
			erc20token.setLocalDecimals(info.localdecimals);
			erc20token.setLocalTotalSupply(info.localtotalsupply);

			// TODO: _apicontrollers.saveERC20Token works only for token on chain (version 0.30.10)
			res = await this._saveLocalERC20Token(session, erc20token);
		}
		else {
			// save token
			res = await _apicontrollers.saveERC20Token(session, erc20token);
		}


		return res;
	}

	async deleteERC20Token(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

	    
		var erc20tokenmodule = global.getModuleObject('erc20');
		var erc20tokencontrollers = erc20tokenmodule.getControllersObject();
		

		erc20tokencontrollers.removeERC20TokenObject(session, erc20token);

		await this._saveERC20Tokens(session);

		return;
	}


	async getERC20TokenTotalSupply(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		return erc20token.getChainTotalSupply();
	}

	async getERC20TokenSymbol(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		return erc20token.getChainSymbol();
	}

	async getERC20TokenName(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		return erc20token.getChainName();
	}

	async getERC20TokenDecimals(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		return erc20token.getChainDecimals();
	}

	async getERC20TokenStatusString(sessionuuid, erc20tokenuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!erc20tokenuuid)
		return Promise.reject('erc20 token uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

	
		var erc20token = this._getERC20TokenFromUUID(session, erc20tokenuuid);

		if (!erc20token)
			return Promise.reject('could not find erc20 token ' + erc20tokenuuid);

		await erc20token.checkStatus();

		var livestatus = erc20token.getLiveStatus();

		if (livestatus)
		return this._getERC20TokenStatusString(livestatus);
	}



// client_wallet level

	//
	// Scheme functions
	//

	async getScheme(sessionuuid, schemeuuid) {
		var global = this.global;
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		return mvcclientwalletmodule.getSchemeInfo(sessionuuid, schemeuuid);
	}

	async createScheme(sessionuuid, schemeconfig) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);
			
		var scheme = await _apicontrollers.createScheme(session, schemeconfig);

		return scheme;
	}

	async setSessionScheme(sessionuuid, schemeuuid) {
		if (!sessionuuid)
			return Promise.reject('session uuid is undefined');
		
		if (!schemeuuid)
			return Promise.reject('scheme uuid is undefined');
		
		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var	scheme = await _apicontrollers.getSchemeFromUUID(session, schemeuuid)
		.catch(err => {});

		if (!scheme)
			return Promise.reject('could not find scheme ' + schemeuuid);
	
		// set network config to the session
		var mvcclientwalletmodule = global.getModuleObject('mvc-client-wallet');
		var network = mvcclientwalletmodule._getSchemeNetworkConfig(scheme);
				
		await _apicontrollers.setSessionNetworkConfig(session, network);

		// save schemeuuid
		session.setSessionVariable('schemeuuid', schemeuuid);
	}

	async getSessionScheme(sessionuuid) {
		// note: clientsmodule does not store info on the schemeuuid
		// we do it at our level (and won't have it if session created by someone else)

		if (!sessionuuid)
		return Promise.reject('session uuid is undefined');

		var global = this.global;
		var _apicontrollers = this._getClientAPI();

		var session = await _apicontrollers.getSessionObject(sessionuuid);
		
		if (!session)
			return Promise.reject('could not find session ' + sessionuuid);

		var schemeuuid = session.getSessionVariable('schemeuuid');

		if (!schemeuuid)
			return Promise.reject('no scheme uuid save in session variables');

		return this.getScheme(sessionuuid, schemeuuid);
	}

}

if ( (typeof GlobalClass === 'undefined') || (!GlobalClass)) {
	var GlobalClass = ((typeof window !== 'undefined') && window && window.simplestore && window.simplestore.Global ? window.simplestore.Global : null);
}

if ( typeof GlobalClass !== 'undefined' && GlobalClass ) {
	GlobalClass.getGlobalObject().registerModuleObject(new Module());

	//dependencies
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-mydashboard', 'common');
	GlobalClass.getGlobalObject().registerModuleDepency('mvc-mydashboard', 'mvc-client-wallet');

	// module classes	
}


